export default "__VITE_ASSET__T7l9TD8g__"